import React from "react";
import { Spinner } from "./Spinner";
import "./LoadingPage.css";

interface LoadingPageProps {
  loadingMessage?: string;
  className?: string;
  disableAnimation?: boolean;
}

export const LoadingPage: React.FC<LoadingPageProps> = ({
  loadingMessage = "Loading...",
  className = "",
  disableAnimation = false,
}) => {
  return (
    <div className={`loading-page ${className}`}>
      <div className="loading-page-content">
        <div className="loading-page-icon">
          <div
            className={`loading-page-thinking-container ${
              disableAnimation ? "loading-page-no-animation" : ""
            }`}>
            <img src="/icons/winslow-ai-logo.svg" alt="" />
          </div>
        </div>
        {loadingMessage && loadingMessage !== "" && (
          <div className="loading-page-message">{loadingMessage}</div>
        )}
      </div>
    </div>
  );
};
